// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"592":"47ef5ad9","970":"47ef5ad9"}[chunkId] + ".chunk.css";
};